export interface CoveredCallChartMarketHours {
  fromTime: string;
  toTime: string;
}

export const getCoveredCallChartMarketHours = (
  recorderKey?: string,
): CoveredCallChartMarketHours => {
  const isCommodity = recorderKey
    ?.split("-")
    .filter(Boolean)
    .some((instrumentId) => !instrumentId.toUpperCase().startsWith("IR"));

  return isCommodity
    ? { fromTime: "12:00:00", toTime: "18:00:00" }
    : { fromTime: "09:00:00", toTime: "12:30:00" };
};
